import { ReactTable } from "@funcional/react-table-ui";
import { useMemo } from "react";
import { Column, useTable } from "react-table";
import { IBeneficiaryFormField } from "../contracts";

export function BeneficiaryFieldsList({
  fields,
}: {
  fields: IBeneficiaryFormField[];
}) {
  const columns: Column<IBeneficiaryFormField>[] = useMemo(
    () =>
      [
        { Header: "Campo", accessor: "text" },
        { Header: "Valor", accessor: "value" },
      ] as Column<IBeneficiaryFormField>[],
    []
  );

  const tableInstance = useTable({
    columns,
    data: fields,
  });

  return <ReactTable compact tableInstance={tableInstance} />;
}
